import { Column, PlanPricingService } from '@/services/api/plan-pricing.service';
import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { debounceTime, Subject } from 'rxjs';

interface PriceUpdate {
  planId: number;
  fid: number;
  price: any;
  ppid: number | null;
}

@Component({
    selector: 'app-plan-pricing',
    imports: [
        TableModule,
        MultiSelectModule,
        ToastModule,
        InputTextModule,
        FormsModule,
        CommonModule,
        TooltipModule
    ],
    template: `
    <p-table 
    [columns]="planPricingService.selectedColumns()" 
    [value]="planPricingService.plansWithPricing()" 
    #pt
    [scrollable]="true" scrollHeight="80vh"
    [rowHover]="true"
    dataKey="PlanID" editMode="row"
    [loading]="planPricingService.loading()"
    [globalFilterFields]="['PlanName', 'Styles.StyleName']"
    [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="caption">
                <div class="flex justify-content-between">
            <p-multiSelect 
                display="chip" 
                [options]="planPricingService.columns()" 
                [(ngModel)]="selectedColumns" 
                optionLabel="header"
                selectedItemsLabel="{0} columns selected" 
                [style]="{'min-width': '200px'}" 
                placeholder="Choose Columns" />
                <input 
                            pInputText 
                            type="text" 
                            [(ngModel)]="searchTerm"
                            (ngModelChange)="pt.filterGlobal($event, 'contains')" 
                            placeholder="Search keyword" />
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th pFrozenColumn>Plan</th>
                <th>Style</th>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
                <th pFrozenColumn>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-plan let-columns="columns" let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="plan" >
                <td>{{ plan.PlanName }}</td>
                <td>{{ plan.Styles.StyleName }}</td>
                <td *ngFor="let col of columns" [pEditableColumn]="plan.pricing[col.fid].price" pEditableColumnField="Price">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input [disabled]="plan.pricing[col.fid].inherit"
                                [pTooltip]="getTooltip(col.fid, plan.pricing[col.fid].inherit)"
                                pInputText type="text" 
                                [(ngModel)]="plan.pricing[col.fid].price" 
                                (ngModelChange)="onPriceChange(plan.PlanID, col.fid, $event, plan.pricing[col.fid].ppid)"
                                required />
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div class="flex align-items-start justify-content-start text-300" [ngClass]="{'text-900': !plan.pricing[col.fid].inherit}">{{(plan.pricing[col.fid].inherit ? plan.pricing[plan.pricing[col.fid].inherit].price : plan.pricing[col.fid].price) | currency}} </div>
                        </ng-template>
                    </p-cellEditor>
                    
                </td>
            </tr>
        </ng-template>
</p-table>
<p-toast position="top-right"></p-toast>
    `
})
export class PlanPricingComponent {
  clonedPlans: any[] = [];
  planPricingService = inject(PlanPricingService);
  private priceUpdateSubject = new Subject<PriceUpdate>();
  searchTerm = '';

  constructor(
  ) {
    effect(() => {
      const col = this.planPricingService.selectedColumns();
      console.log(col);
    });
    this.priceUpdateSubject.pipe(
      debounceTime(500) // Wait 500ms after the last emission
    ).subscribe(update => {
      this.planPricingService.updatePlanPrice(
        update.planId,
        update.fid,
        update.price,
        update.ppid
      );
    });
  }

  get selectedColumns() {
    return this.planPricingService.selectedColumns();
  }

  set selectedColumns(value: Column[]) {
    this.planPricingService.selectedColumns.set(value);
  }

  onRowEditInit(plan: any) {
    this.clonedPlans[plan.PlanID] = { ...plan };
}

onPriceChange(planId: number, fid: number, event: any, ppid: number | null) {
  this.priceUpdateSubject.next({
    planId,
    fid,
    price: event,
    ppid
  });
}

onRowEditSave(plan: any) {
    if (plan.PlanID > 0) {
      console.log('plan edited', plan);
        delete this.clonedPlans[plan.PlanID];
        
    } else {
        
    }
}

getTooltip(fid: number, inherit?: number) {
  if (inherit === fid || inherit === 0 || inherit === null) {
    return 'Edit Price';
  } else {
    const office = this.planPricingService.getOffices().find(o => o.FID === inherit);
    return 'This price is inherited from ' + office?.CityCode;
  }
}

onRowEditCancel(plan: any, index: number) {
    this.planPricingService.plansWithPricing()[index] = this.clonedPlans[plan.PlanID];
    delete this.clonedPlans[plan.PlanID];
}

filtertest(event: any) {
  console.log(event);
}
  

ngOnDestroy() {
  this.priceUpdateSubject.complete();
}

}
